export const proportionalReasons = [
  {
    id: "1",
    description: 'Type Of Activity',
  },
  {
    id: "2",
    description: 'Market',
  },
  {
    id: "3",
    description: 'Result',
  },
  {
    id: "4",
    description: 'Risk Quality',
  },
  {
    id: "5",
    description: 'Other',
  },
];

export const proportionalReasonsInteger = [
  {
    id: 1,
    description: 'Type Of Activity',
  },
  {
    id: 2,
    description: 'Market',
  },
  {
    id: 3,
    description: 'Result',
  },
  {
    id: 4,
    description: 'Risk Quality',
  },
  {
    id: 5,
    description: 'Other',
  },
];
